export default __webpack_public_path__ + "static/media/CabinetGrotesk-Light.ef578021.woff2";